<template>
    <div class="community-page">
        <container size="lg" class="p-x-small-28">
            <section class="m-b-32">
                <div class="p-y-80 p-y-small-0">
                    <Hero
                        image="community/heading.png"
                        image-class=""
                        :image-style="{ backgroundPosition: 'left'}"
                        hero-class=""
                        :image-width="isDesktop ? '275px': '133px'"
                        :image-height="isDesktop ? '291px' : '141px'"
                        :hide-button="true"
                        hero-content-class=""
                        heading-text="Harness the Power of Targeted Consumer Product Experiences"
                        btn-text="Talk to an expert"
                    >
                        <template #header>
                            <div>
                                <Heading
                                    class="text-color f-w-700 f-s-small-20 m-b-24 m-b-small-16"
                                    tag="h2"
                                    size="web-x-sm"
                                    style="letter-spacing: -0.5px; color: #009B8E;"
                                >
                                    Peekage Community
                                </Heading>

                                <Heading
                                    color="primary"
                                    class="f-w-700 f-s-small-44 m-b-24 m-b-small-16"
                                    tag="h2"
                                    size="web-xxx-lg"
                                    style="letter-spacing: -1px;"
                                >
                                    Where Passionate Shoppers Meet Innovative Brands!
                                </Heading>
                            </div>
                        </template>
                    </Hero>

                    <div>
                        <p class="font f-s-24 l-h-32 f-w-600 f-s-small-20 m-0">
                            At Peekage, we've cultivated a dynamic community of enthusiastic natural shoppers who are always on the lookout for their next favorite find. Our members are more than just consumers; they're trendsetters and influencers in their own right, serious about sharing their feedback and eager to experience the latest products and innovations before anyone else.
                        </p>
                    </div>
                </div>
            </section>
        </container>

        <container size="lg" class="p-x-medium-16 p-x-small-16">
            <section class="p-y-40 d-flex flex-column" style="gap: 32px;">
                <p class="font Roboto f-s-36 f-w-700 l-h-40 l-t-s-75 m-0" :style="{textAlign: isDesktop ? 'start' : 'center'}">
                    What Our Community <span class="font Roboto f-s-36 f-w-700 l-h-40 l-t-s-75 love" style="color: #FF3C55;">Loves</span> to Do
                </p>
                <div class="row align-items-center" :class="{'flex-column-reverse' : $device.mobile}">
                    <div class="col-md-6">
                        <div class="d-flex flex-column" style="gap: 32px">
                            <communityLovesRow v-for="(row, i) in communityLoves" :key="i" :row="row" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img class="w-100 h-auto" :src="$image('community/loversWithHashtag.png')">
                    </div>
                </div>
            </section>

            <div class="padding-y-80">
                <p class="m-0 p-b-32 font f-s-18 f-w-700 l-h-28 text-center">
                    Upon joining Peekage, members complete their profile by sharing their personal preferences, eating habits, diets, interests, shopping behaviors, and more. The rich first-party data from our community members helps you build highly targeted campaigns and match them with desired ones. Those intrigued by your offering opt-in, ready to engage, explore, and elevate your brand.
                </p>
            </div>

            <section class="d-flex flex-column p-y-40" style="gap: 48px;">
                <SnapShotContainer />
            </section>

            <section class="p-y-96 d-flex flex-column p-y-small-40" style="gap: 41px;">
                <div>
                    <h2 class="font Roboto f-s-37 f-w-700 l-h-40 l-t-s-75 community-header" :style="{textAlign: isDesktop ? 'center' : 'start'}">
                        See Our Community
                    </h2>
                </div>
                <two-row-slider />
            </section>
        </container>
        <container size="lg">
            <section class="p-l-small-0 p-r-small-0 p-t-40">
                <Banner :btn-text="btnText">
                    <template #content>
                        <Heading
                            color="on-color"
                            class="f-w-600 f-s-small-28 l-h-small-36 text-center text-lg-left m-b-0"
                            tag="p"
                            size="x-lg"
                        >
                            Find out how peekage can exceed your business goals
                        </Heading>
                    </template>
                </Banner>
            </section>
        </container>
    </div>
</template>

<script>
import Hero from '~/components/common/hero';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import SnapShotContainer from '~/components/common/community/snapshot/SnapShotContainer';
import Banner from '~/components/common/banner';
import CommunityLovesRow from '../components/common/community/communityLovesRow';
import TwoRowSlider from '../components/common/slick-slider/twoRowSlider';

const loves = [
    {
        title: 'Sample and Advocate',
        caption: 'Be the first to try new products, becoming champions for innovation.',
        imgUrl: 'community/newPinkCloud.png',
    },
    {
        title: 'Share Reviews',
        caption: 'Offer honest, insightful online feedback that resonates with a wider audience.',
        imgUrl: 'community/starInCloud.png',
    },
    {
        title: 'Support Retail Velocity',
        caption: 'Visit stores to purchase your products, directly influencing sales and help building better buyer relationships.',
        imgUrl: 'community/store.png',
    },
    {
        title: 'Social Media Buzz',
        caption: 'Amplify your brand’s message, sharing experiences with an expansive network.',
        imgUrl: 'community/palmWithHeart.png',
    },
    {
        title: 'Provide Valuable Feedback',
        caption: 'Be proactive in sharing targeted feedback post-testing, aiding in the optimization of both product performance and marketing tactics.',
        imgUrl: 'community/message.png',
    },
    {
        title: 'Engage in Research',
        caption: 'Participate in detailed product testing throughout product development, offering nuanced insights.',
        imgUrl: 'community/checkedClipboard.png',
    },
];

export default {
    name: 'Community',
    components: {
        Hero,
        CommunityLovesRow,
        Banner,
        TwoRowSlider,
        SnapShotContainer,
    },
    layout: 'xerneas',
    data() {
        return {
            communityLoves: [],
            isDesktop: false,
        };
    },
    head() {
        return {
            title: 'Peekage Natural Shoppers Community',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: "Leverage Peekage's diverse community of natural shoppers to gain valuable insights into your product's performance, garner reviews, generate social media buzz, and increase retail velocity.",
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: 'natural shopper community',
                },
            ],
            link: [
                {
                    rel: 'canonical',
                    href: 'https://peekage.com/natural-shoppers-community',
                },
            ],
        };
    },
    computed: {
        btnText() {
            return this.isDesktop ? 'Book a demo' : 'Let\'s set a goal';
        },
    },
    mounted() {
        this.checkScreenSize();
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeMount() {
        this.communityLoves = loves;
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        checkScreenSize() {
            this.isDesktop = window.innerWidth >= 768;
        },
    },
};
</script>

<style lang="scss" scoped>
.community-page {
    .hero {
        align-items: flex-start;
        flex-flow: column-reverse;
        gap: 0px;
    }

    @media (max-width: 768px) {

    }

    @media only screen and (min-width: 992px) {
        .hero {
            flex-flow: inherit;
            gap: 16px;
        }
    }
}
</style>
